import { render, staticRenderFns } from "./AuthBusinessDialog.vue?vue&type=template&id=2b63e7a0&scoped=true&"
import script from "./AuthBusinessDialog.vue?vue&type=script&lang=js&"
export * from "./AuthBusinessDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b63e7a0",
  null
  
)

export default component.exports